var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowThinUpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40731 12.6822V2.69618L1.00614 5.98602C0.777485 6.20898 0.405027 6.21066 0.174235 5.98976C-0.0565585 5.76886 -0.0582909 5.40903 0.170365 5.18607L0.174753 5.18184L4.58441 0.916611C4.81349 0.694809 5.18532 0.694413 5.41491 0.915726L9.82551 5.18184C10.0565 5.40262 10.0584 5.76246 9.82987 5.98556C9.60133 6.20866 9.22886 6.21055 8.99792 5.98977L8.99404 5.98602L5.58288 2.68655V12.6822C5.58288 12.9958 5.31972 13.25 4.99509 13.25C4.67047 13.25 4.40731 12.9958 4.40731 12.6822Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowThinUpWhite);
export default __webpack_public_path__ + "static/media/arrowThinUpWhite.77c99777ba9adbaf97908ecf84ac43a4.svg";
export { ForwardRef as ReactComponent };